import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import md5Hex from "md5-hex";
import Api from "../Api/Api.json";
import { InstallApk } from "../components/InstallAPK";
import MainContainer from "../components/Container/MainContainer";
import FormContainer from "../components/Container/FormContainer";
import FormHeader from "../components/Header/FormHeader";
import TextInput from "../components/Input/TextInput";
import PasswordInput from "../components/Input/PasswordInput";
import FormError from "../components/Error/FormError";
import SubmitButton from "../components/Button/SubmitButton";
import Button from "../components/Button/Button";
import { processUsername } from "../utils";

const LoginPage = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError: setFormError,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    if (localStorage.getItem("user_info") !== null) {
      InstallApk();
      console.log("called apk install check");
      navigate("/landing/questionanswer");
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    const processedUsername = processUsername(data.username);
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PATIENT_API;
    const requestData = {
      task: "authenticatePatient",
      phone: processedUsername,
      password: md5Hex(data.password),
    };

    try {
      const response = await axios.post(url, requestData, headers);
      console.log(response.data);

      if (response.data.length > 0) {
        localStorage.setItem("user_info", JSON.stringify(response.data[0]));
        navigate("/landing/questionanswer");
      } else {
        setFormError("root", {
          type: "manual",
          message: "Invalid credentials. Please try again.",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      setFormError("root", {
        type: "manual",
        message: "Server error. Please try again later.",
      });
    }
  };

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <MainContainer
      background="bg-gray-50"
      py="py-12"
      px="px-4"
      sm_px="sm:px-6"
      lg_px="lg:px-8"
      flex="flex"
      main_axis="justify-center"
      cross_axis="items-center"
      flex_direction="flex-row"
    >
      <FormContainer width="max-w-md" spacing="space-y-8">
        <FormHeader
          title="Welcome to EnergyBand App"
          subTitle="Sign in to your account"
          titleColor="text-gray-900"
          subTitleColor="text-gray-600"
        />

        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="rounded-md shadow-sm space-y-4">
            <TextInput
              id="username"
              label="User ID (phone/semion ID)"
              placeholder="Enter your phone number or ID"
              register={register("username", {
                required: "User ID is required",
                pattern: {
                  value: /^[0-9]+$/,
                  message: "User ID must be numeric",
                },
              })}
              errors={errors}
            />
            <PasswordInput
              id="password"
              label="Password"
              placeholder="Enter your password"
              register={register("password", {
                required: "Password is required",
                // minLength: {
                //   value: 6,
                //   message: "Password must be at least 6 characters",
                // },
              })}
              errors={errors}
            />
          </div>

          <FormError message={errors.root?.message} />

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label
                htmlFor="remember-me"
                className="ml-2 block text-sm text-gray-900"
              >
                Remember me
              </label>
            </div>
            {/*   
            <div className="text-sm">
              <a
                href="#"
                className="font-medium text-blue-600 hover:text-blue-500"
              >
                Forgot your password?
              </a>
            </div>
            */}
          </div>
              
          <div className="space-y-3">
            <SubmitButton
              disabled={isSubmitting}
              enabledLabel="Sign in"
              disabledLabel="Signing in..."
              width="w-full"
              borderColor="border-transparent"
              textColor="text-white"
              backgroundColor="bg-blue-600"
              hoverBackgroundColor="hover:bg-blue-700"
              focusRingColor="focus:ring-blue-500"
              disabledOpacity="opacity-50"
            />
            <Button
              type="button"
              onClick={() => navigate("/registration")}
              label="Don't have an account? Register"
              rounded="rounded-md"
              width="w-full"
              borderColor="border-gray-300"
              textColor="text-gray-700"
              backgroundColor="bg-white"
              hoverBackgroundColor="hover:bg-gray-50"
              focusRingColor="focus:ring-blue-500"
            />
          </div>
        </form>
      </FormContainer>
    </MainContainer>
  );
};

export default LoginPage;
